import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// MUI Date Picker
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const AddUserForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    username: "",
    password: "",
    email: "",
    phone: "",
    role: "",
    validity: "",
    company: "non",
    refund_to_parent: null,
    parent_username: "sagar124",
    creater_role: "admin",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClose = () => {
    navigate("/users");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(
        "https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/register",
        {
          name: formData.name,
          username: formData.username,
          phone: formData.phone,
          role: formData.role,
          company: formData.company,
          password: formData.password,
          email: formData.email,
          refund_to_parent: formData.refund_to_parent,
          parent_username: formData.parent_username,
          creater_role: formData.creater_role,
          validity: formData.validity,
        }
      );

      if (response.status === 200) {
        navigate("/users", { state: { userAdded: true } });
      } else {
        setError("Something went wrong. Try again.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "API request failed");
    } finally {
      setLoading(false);
    }
  };

  const inputPropsStyle = {
    sx: {
      backgroundColor: "#fff",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      borderRadius: "12px",
      height: 40,
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "12px",
      },
    },
    inputProps: {
      style: {
        padding: "8px 14px",
      },
    },
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        position: "relative",
        width: 400,
        mx: "auto",
        my: 4,
        p: 3,
        border: "1px solid #ccc",
        borderRadius: 3,
        boxShadow: 4,
        backgroundColor: "#f0f2f5",
      }}
    >
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          color: "#999",
          "&:hover": {
            color: "#000",
          },
        }}
      >
        <CloseIcon />
      </IconButton>

      <Typography variant="h6" sx={{ mb: 2, color: "#3f51b5" }}>
        Add User
      </Typography>

      {error && <Typography color="error">{error}</Typography>}
      {success && <Typography sx={{ color: "green" }}>{success}</Typography>}

      <Typography variant="body2">Full Name :</Typography>
      <TextField
        fullWidth
        label="Full name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        margin="normal"
        InputProps={inputPropsStyle}
      />

      <Typography variant="body2">Username :</Typography>
      <TextField
        fullWidth
        label="Username"
        name="username"
        value={formData.username}
        onChange={handleChange}
        margin="normal"
        InputProps={inputPropsStyle}
      />

      <Typography variant="body2">Password :</Typography>
      <TextField
        fullWidth
        label="Password"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleChange}
        margin="normal"
        InputProps={inputPropsStyle}
      />

      <Typography variant="body2">Email :</Typography>
      <TextField
        fullWidth
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        margin="normal"
        InputProps={inputPropsStyle}
      />

      <Typography variant="body2">Phone :</Typography>
      <TextField
        fullWidth
        label="Phone"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        margin="normal"
        InputProps={inputPropsStyle}
      />

      <FormControl fullWidth margin="normal">
        <InputLabel>Select Role</InputLabel>
        <Select
          name="role"
          value={formData.role}
          onChange={handleChange}
          label="Select Role"
          sx={{
            backgroundColor: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            borderRadius: "8px",
            height: 40,
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "8px",
            },
          }}
        >
          <MenuItem value="Sub Admin">Sub Admin</MenuItem>
          <MenuItem value="Admin">Admin</MenuItem>
          <MenuItem value="User">User</MenuItem>
        </Select>
      </FormControl>

      <Typography variant="body2">Validity :</Typography>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Validity"
          value={formData.validity ? new Date(formData.validity) : null}
          onChange={(newValue) => {
            const formattedDate = newValue
              ? newValue.toISOString().slice(0, 10) // yyyy-mm-dd format
              : "";
            setFormData((prev) => ({
              ...prev,
              validity: formattedDate,
            }));
          }}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="normal"
              {...params}
              InputProps={{
                ...params.InputProps,
                ...inputPropsStyle,
              }}
            />
          )}
        />
      </LocalizationProvider>

      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={loading}
        sx={{
          mt: 2,
          background: "linear-gradient(to right, #bbdefb, #4364F7)",
          color: "black",
          boxShadow: 3,
          fontWeight: "bold",
          borderRadius: "8px",
          "&:hover": {
            background: "linear-gradient(to right, #bbdefb, #354ACB)",
          },
          height: 40,
          textTransform: "none",
        }}
      >
        {loading ? "Creating..." : "Create"}
      </Button>
    </Box>
  );
};

export default AddUserForm;
